<template>
  <div class="normal-toggle-chart">
    <basic-container>
      <div class="header__date" flex="cross:center">
        <div
          v-for="(item,index) in tooggleDate"
          :key="index"
          class="header__date-row"
          flex="cross:center"
          :class="tooggleDateIndex === index?'header__date-row--active':''"
          @click="onHandleToggleDate(item,index)"
        >{{item}}</div>
      </div>

      <ve-pie :data="chartData" :settings="chartSettings" height="400px" legend-position="bottom"></ve-pie>
    </basic-container>
  </div>
</template>

<script>
import BasicContainer from "@vue-materials/basic-container";
import VePie from "v-charts/lib/pie";
export default {
  components: { BasicContainer, VePie },
  name: "PayChart",
  data() {
    this.chartSettings = {
      labelMap: {
        PV: "test1",
        Order: "test2"
      },
      // roseType: 'radius',
      // dimension: "type",
      // dataType: "percent",
      offsetY: 150
    };
    return {
      tooggleDateIndex: 0,
      tooggleDate: ["支付方式", "终端方式"],

      chartData: {
        columns: ["type", "percentage"],
        rows: [
        ]
      }
    };
  },
  methods: {
    onHandleToggleDate(item, index) {
      this.tooggleDateIndex = index;
        if(index==1){
            console.info("=====index===="+index);
            this.$emit('refreshpay');
        }else{
            this.$emit('refreshpay2');
        }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  &__date {
    display: inline-block;
    height: 30px;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
    float: left;
        font-size: 14px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }
}
</style>
